import createCrudVuexModule from "@/store/crud";

export const dataCategory = createCrudVuexModule({
  namespaced: true,
  path: "/library/data-category",
});

export const data = createCrudVuexModule({
  namespaced: true,
  path: "/library/data",
});

export const workspaceDataCategory = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/data-category",
});

export const managementDataCategory = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/data-category",
});

export const workspaceData = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/data",
});

export const managementData = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/data",
});
